export const routePaths = {
    blogs: 'blogs',
    blogsList: 'blogs/site/:blogId',
    blogSetting: 'blogs/site/:blogId/setting',
    blogImport: 'blogs/site/:blogId/import',
    blogImportId: 'blogs/site/:blogId/import/:importId',
    blogCsvImport: 'blogs/site/:blogId/csv-import',
    blogCsvImportId: 'blogs/site/:blogId/csv-import/:importId',
    blogCsvPostEditor: 'blogs/site/:blogId/csv-post-editor/:linkId',
    blogNew: 'blogs/site/create/new',
    blogsSettings: 'blogs/settings/',
    blogsPostEdit: 'blogs/post/:postId/edit',
    blogsPostSettings: 'blogs/post/:postId/settings',
    blogsPostPreview: 'blogs/post/:postId/preview',
    blogsPostVersions: 'blogs/post/:postId/versions',
    blogsInvalidRoutes: {
        blogPost: 'blogs/post',
        blogPostWithId: 'blogs/post/:postId',
        blogsAuthors: 'blogs/settings/authors',
        blogsAuthorsEdit: 'blogs/settings/authors/:authorId/edit',
        blogsCategories: 'blogs/settings/categories',
        blogsCategoriesEdit: 'blogs/settings/categories/:categoryId/edit',
    },
    emailServices: 'email_services',
    agencyDedicatedDomains: 'email_services/dedicated-domains',
    agencyAddDomain: 'email_services/dedicated-domains/add-domain',
    agencyVerifyDomain: 'email_services/dedicated-domains/verify-domain',
    agencyOPMTrafficStats: 'email_services/outlook-postmaster/traffic-stats',
    smtpServices: 'smtp_service',
    emailServicesDedicatedDomains: 'smtp_service/dedicated-domains',
    emailServicesAddDomain: 'smtp_service/dedicated-domains/add-domain',
    emailServicesVerifyDomain: 'smtp_service/dedicated-domains/verify-domain',
    blacklistMonitorReports: 'smtp_service/blacklist-monitor-reports',
    mobileAppCustomiser: '/mobile-app-customiser',
    emailServicesSmtpSettings: 'smtp_service/dedicated-domains/smtp-settings',
    emailServicesOPMTrafficStats: 'smtp_service/outlook-postmaster/traffic-stats',
    emailServicesGPMTrafficStats: 'smtp_service/google-postmaster/traffic-stats'
}
